/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelClassEnum } from './ModelClassEnum';
import { ModelClassEnumFromJSON, ModelClassEnumFromJSONTyped, ModelClassEnumToJSON } from './ModelClassEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PerturbedDatasetPolymorphicPerturbedTabularMLDataset
 */
export interface PerturbedDatasetPolymorphicPerturbedTabularMLDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedTabularMLDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedTabularMLDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedDatasetPolymorphicPerturbedTabularMLDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedTabularMLDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedTabularMLDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedDatasetPolymorphicPerturbedTabularMLDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {ModelClassEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedTabularMLDataset
   */
  modelClass: ModelClassEnum;
}

/**
 * Check if a given object implements the PerturbedDatasetPolymorphicPerturbedTabularMLDataset interface.
 */
export function instanceOfPerturbedDatasetPolymorphicPerturbedTabularMLDataset(
  value: object,
): value is PerturbedDatasetPolymorphicPerturbedTabularMLDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('modelClass' in value) || value['modelClass'] === undefined) return false;
  return true;
}

export function PerturbedDatasetPolymorphicPerturbedTabularMLDatasetFromJSON(
  json: any,
): PerturbedDatasetPolymorphicPerturbedTabularMLDataset {
  return PerturbedDatasetPolymorphicPerturbedTabularMLDatasetFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicPerturbedTabularMLDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphicPerturbedTabularMLDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    modelClass: ModelClassEnumFromJSON(json['model_class']),
  };
}

export function PerturbedDatasetPolymorphicPerturbedTabularMLDatasetToJSON(
  value?: Omit<PerturbedDatasetPolymorphicPerturbedTabularMLDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    model_class: ModelClassEnumToJSON(value['modelClass']),
  };
}
